import { WIDGET_FORM_INPUT_I18N } from "@smallstack/typesystem";
import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const I18nInputWidget: WidgetRegistryEntry = {
  name: WIDGET_FORM_INPUT_I18N,
  component: () => import("./i18n-input-widget.component").then((m) => m.I18nInputWidgetComponent)
};
